export const MyTasksTableStyles = {
  container: {},
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  imageContainer: {
    display: "flex",
    gap: "20px",
  },
  drawer: {
    width: "50%",
  },
  taskNameStyles: {
    wordWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "200px",
  },
  customerNameStyles: {
    wordWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "150px",
  },
  descriptionStyles: {
    wordWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "250px",
  },
};
